import { createSlice } from "@reduxjs/toolkit";

/**
 *
 * @type IndustryStoreState
 */
const initialState = {
  getSideMenuList: { loading: false, data: null, error: null },
};

export const SideMenuSlice = createSlice({
  name: "getSideMenu",
  initialState,
  reducers: {
    fetchSideMenuRequest: (state, action) => {
      state.getSideMenuList.loading = true;
      state.getSideMenuList.error = null;
    },
    fetchSideMenuSuccess: (state, action) => {
      state.getSideMenuList.data = action.payload;
      state.getSideMenuList.loading = false;
      state.getSideMenuList.error = null;
    },
    fetchSideMenuFailure: (state, action) => {
      state.getSideMenuList.data = null;
      state.getSideMenuList.loading = false;
      state.getSideMenuList.error = action.payload;
    },
  },
});

export const {
  fetchSideMenuRequest,
  fetchSideMenuSuccess,
  fetchSideMenuFailure,
} = SideMenuSlice.actions;

export const getSideMenuState = (store) => store.sidemenu?.getSideMenuList;

export default SideMenuSlice.reducer;
